import { InputPassword } from '../../../@core/components/form/Password';
import { Textarea } from '../../../@core/components/form/Textarea';
import { Toggle } from '../../../@core/components/form/Toggle';
import { Subtitle } from '../../../@core/components/form/Subtitle';
import { Title } from '../../../@core/components/form/Title';
import { Input } from '../../../@core/components/form/Input';
import { MultiSelect } from '../../../@core/components/form/MultiSelect';
import { Select } from '../../../@core/components/form/Select';
import { CardInterpreter } from '../../../@core/components/interpreter/CardInterpreter';
import { Readonly } from '../../../@core/components/form/Readonly';
import { Radio } from '../../../@core/components/form/Radio';

export const SelectorComponent = (component) => {
  if (component.component) return component.component;
  console.log('a');
  switch (component.type) {
    case 'select':
      return component.isMulti ? MultiSelect : Select;
    case 'toggle':
      return Toggle;
    case 'password':
      return InputPassword;
    case 'area':
      return Textarea;
    case 'radio':
      return Radio;
    case 'title':
      return Title;
    case 'subTitle':
      return Subtitle;
    case 'void':
      return null;
    case 'card':
      return CardInterpreter;
    case 'readonly':
      return Readonly;
    case 'blank':
      console.log('a');
      return (
        <div>
          <label className="control-label text-left fw-bold"></label>
          <p className="form-control-plaintext "></p>
        </div>
      );
    default:
      return Input;
  }
};
